







import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import editor from 'vue2-ace-editor'
import { JSZipObject } from 'jszip'

import { Function } from '../api/functions'
import { TreeItem, TreeItemDirectory } from '../model/filetree'
import FileTree from './FileTree.vue'

@Component({
  components: {
    FileTree,
    editor
  },
  computed: mapState({
    fileContents: (state: any) => state.packages.fileContents
  })
})
export default class FunctionEditor extends Vue {
  currentFile = ''

  editorInit () {
    require('brace/ext/language_tools')
    require('brace/mode/javascript')
    require('brace/mode/golang')
    require('brace/mode/perl')
    require('brace/mode/python')
    require('brace/theme/xcode')
  }

  openFile (filePath: string) {
    this.currentFile = filePath
    this.$store.dispatch('packages/fileContents', filePath)
  }

  setFileContents (content: string) {
    this.$store.commit('packages/setFileContents', { file: this.currentFile, content: content })
  }

  get tree () {
    if (!this.$store.state.packages.currentZip) {
      return []
    }

    const pkg = this.$store.state.packages.currentZip
    const paths = Object.keys(pkg.files)

    const t: TreeItemDirectory[] = []

    for (const filePath of paths) {
      const path = filePath.split('/')

      let currentDir: TreeItemDirectory = {
        type: 'dir',
        tree: t,
        name: 'Package'
      }

      for (const idx in path) {
        const part = path[idx]
        let newDir = currentDir.tree.find((e: TreeItem) => e.name === part)

        if (!newDir) {
          newDir = currentDir.tree[currentDir.tree.push({
            name: part,
            type: parseInt(idx) === path.length - 1 ? 'file' : 'dir',
            tree: []
          }) - 1]
        }

        if (newDir.type === 'dir') {
          currentDir = newDir
        } else {
          break
        }
      }
    }

    return t
  }
}
